// @flow
export {
  default as Locales,
  availableLocales,
  createLocalesWithConfiguredErrors,
} from "./Locales";

export { default as Message } from "./Message";
export { default as withMessage } from "./withMessage";
export { useMessage, useTranslate } from "../hooks/useI18n";

export type * from "./types";
